import { compare } from 'compare-versions';

export const isThereNewVersion = (
  metaVersion: string,
  providedVersion: string,
) => {
  return compare(metaVersion, providedVersion, '>');
};
